<template>
  <FullCalendar ref="innerCalendar" :options="mergedOptions" />
</template>

<script setup>
import {defineProps, computed, ref} from 'vue';
import FullCalendar from '@fullcalendar/vue3';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';

const props = defineProps({
  calendarOptions: {
    type: Object,
    required: true
  },
  defaultView:{
    type: String,
    default: 'dayGridMonth'
  }
});

const innerCalendar = ref(null);
defineExpose({
  getApi: () => innerCalendar.value.getApi()
});

const mergedOptions = computed(() => {
  const defaultView = props.defaultView;
  const isMobile = window.innerWidth < 768;

  return {
    ...props.calendarOptions,
    plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: isMobile ? '' : 'dayGridMonth,timeGridWeek,timeGridDay'
    },
    initialView: defaultView,
    dayHeaderContent: function(arg) {
      if (isMobile) {
        const dayName = arg.date.toLocaleDateString('en-US', { weekday: 'long' });
        const firstLetter = dayName.charAt(0).toUpperCase();
        const dayNumber = arg.date.getDate();
        return {
          html: `<div style="line-height: 1.2;">
                   <div style="font-weight: bold; font-size: 0.9em;">${firstLetter}</div>
                   <div style="font-size: 0.8em;">${dayNumber}</div>
                 </div>`
        };
      }
      return arg.text;
    },
    height: 'auto',
    aspectRatio: isMobile ? 0.8 : 1.35,
    slotMinWidth: isMobile ? 50 : undefined,
    eventDidMount: function(info) {
      info.el.style.cursor = 'pointer';
      info.el.style.touchAction = 'manipulation';
      info.el.addEventListener('touchstart', function(e) {
        e.stopPropagation();
      });
    },
    eventMouseEnter: function(info) {
      info.el.style.cursor = 'pointer';
    },
    longPressDelay: 0,
    eventLongPressDelay: 0
  };
});

</script>

<style>
@media (max-width: 480px) {
  .fc .fc-toolbar {
    flex-direction: column;
    align-items: stretch;
    text-align: center;
  }

  .fc .fc-toolbar-chunk {
    width: 100% !important;
    margin-bottom: 0.5rem;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 0.25rem;
  }

  .fc .fc-toolbar-title {
    font-size: 1rem;
    font-weight: 600;
  }

  .fc .fc-button-group {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 0.25rem;
  }

  .fc .fc-button {
    padding: 0.35rem 0.6rem;
    font-size: 0.75rem;
    min-width: 60px;
  }
}
</style>
